export default function MidCTA() {
  const handleNav = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7e9f140d98ef91dc85d2243a43a04b88.jpg"
          alt="Comfortable home interior"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0066aa]/88" />
        <div
          className="absolute inset-0"
          style={{ backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 30px, rgba(255,255,255,0.04) 30px, rgba(255,255,255,0.04) 31px)' }}
        />
      </div>
      <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-10 text-center">
        <span className="inline-block bg-white/15 text-white text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-5">
          Available 24/7
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Need HVAC Service You Can Count On?
        </h2>
        <p className="text-white/85 text-lg mb-8 max-w-lg mx-auto">
          Request a quote or schedule service today — fast response, transparent pricing, no hidden fees.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={handleNav}
            className="bg-white text-[#0066aa] font-bold text-base px-10 py-4 rounded-full hover:bg-gray-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Request Service
          </button>
          <a
            href="tel:9193489399"
            className="border-2 border-white text-white font-semibold text-base px-10 py-4 rounded-full hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Call (919) 348-9399
          </a>
        </div>
      </div>
    </section>
  );
}
